export default function MySQL_LOG() {
  return (
    <div>
      <h2>MySQL_LOG</h2>    </div>
  );
}